module.exports = __webpack_public_path__ + "static/media/growth-up.2a23fd92.svg";